
export const totalIncomeConfig: StatCardConfig = {
  id: "income",
  title: "Total Income",
  value: "$6,280",
  change: "+18% last month",
  changeColor: "text-purple",
  bg: "bg-purple-soft",
  iconColor: "text-purple",
  iconBg: "bg-purple-icon",
  chartColor: "#7b61ff",
  chartType: "line",
  chartData: [
    { v: 20 },
    { v: 35 },
    { v: 28 },
    { v: 45 },
    { v: 38 },
    { v: 55 },
    { v: 48 },
  ],
};
